import { render, staticRenderFns } from "./LowBatteryList.vue?vue&type=template&id=9aeab3fe&scoped=true&"
import script from "./LowBatteryList.vue?vue&type=script&lang=js&"
export * from "./LowBatteryList.vue?vue&type=script&lang=js&"
import style0 from "./LowBatteryList.vue?vue&type=style&index=0&id=9aeab3fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aeab3fe",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDataTable,VPagination,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9aeab3fe')) {
      api.createRecord('9aeab3fe', component.options)
    } else {
      api.reload('9aeab3fe', component.options)
    }
    module.hot.accept("./LowBatteryList.vue?vue&type=template&id=9aeab3fe&scoped=true&", function () {
      api.rerender('9aeab3fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Reports/LowBatteryList.vue"
export default component.exports